// extracted by mini-css-extract-plugin
module.exports = {"top":"ReadyTo_top__chRXk","title":"ReadyTo_title__60cJk","info":"ReadyTo_info___M7AG","btns":"ReadyTo_btns___ZoGl","button":"ReadyTo_button__LFUoZ"};